import { useApi } from '@/api';
import { LinkButton } from '@/components';
import {
  useIsMobile,
  HeatmapActivity,
  HeatmapSkeleton
} from '@blockanalitica/ui';
import { HeatmapData } from '@blockanalitica/ui/package/types/src/components/charts/Heatmap/Heatmap';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router';

interface ActivityProps {
  url: string;
  linkTo: string;
  onClickUrl?: string | undefined;
}

export default function Activity({
  url,
  linkTo,
  onClickUrl = undefined
}: ActivityProps) {
  const isMobile = useIsMobile();
  const daysAgo = isMobile ? 120 : 365;
  const [data, error] = useApi<HeatmapData[]>({
    url: url,
    queryParams: {
      days_ago: daysAgo
    }
  });

  const theme = useTheme();
  const navigate = useNavigate();

  function onClickCallback(
    //@ts-ignore
    e: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    { date }: HeatmapData
  ) {
    navigate(`${onClickUrl}?date=${date.split('T')[0]}`, { relative: 'path' });
  }

  if (error) throw error;

  if (!data) {
    return <HeatmapSkeleton />;
  }

  return (
    <HeatmapActivity
      title="Activity"
      action={
        <LinkButton variant="secondary" to={linkTo}>
          view all
        </LinkButton>
      }
      data={data}
      daysAgo={daysAgo}
      options={{
        heatColor: theme.colors.primary,
        onClickCallback: onClickUrl ? onClickCallback : undefined
      }}
    />
  );
}
